// 1.导入路由
import {createRouter,createWebHistory} from "vue-router";
import yzPage from "../components/yzPage.vue";

// 3.映射路径
const routes = [
    // {path:"/",component:MyDemo2},
    {path:"/yzPage",component:yzPage}
  ]

  // 4.将映射路径与路由对象进行绑定
const router = createRouter({
    history:createWebHistory(),
    routes:routes
  })

// 4。将路由对象传入Vue对象
export default router;